import React from 'react'
import { Box, Typography } from '@mui/material'

import { useAuth } from './AuthProvider'

import { getImageUrl, truncate } from '../utils/apiHelpers'
import DefaultPfp from '../img/default_pfp.jpeg'

const Leaderboard = ({stats, name, suffix, colors}) => {
    const { user } = useAuth();

    return (
    <div>
        <Typography
            variant="h3"
            color={colors.gray[100]}
            fontWeight="medium"
            sx={{m: "0 0 5px 0"}}
            >
            {name}
        </Typography>
        <Box display="flex" flexDirection="column" justifyContent="flex-start" gap="5px">
            {
                stats !== undefined ?
                stats.map((stat) => (
                    <Box display="flex" alignItems="center">
                        <img src={stat.pfp !== "" ? getImageUrl(stat.pfp) : DefaultPfp} width="30px" height="30px"/>
                        <Typography
                            variant="h5"
                            color={user.name === stat.name ? colors.ceriseAccent[100] : colors.gray[100]}
                            fontWeight={user.name === stat.name ? "bold" : "regular"}
                            sx={{m: "0 5px 0 5px"}}
                            >
                            {truncate(stat.name, 8)}:
                        </Typography>
                        <Typography
                            variant="h5"
                            color={colors.gray[100]}
                            fontWeight="regular"
                            sx={{m: "0 0 0 0"}}
                            >
                            {stat.value}{suffix}
                        </Typography>
                    </Box>
                ))
                : null
            }
        </Box>
    </div>
    )
}

export default Leaderboard